module.exports = __webpack_public_path__ + "static/media/Y.ea57f4dd.png";